export const TEMPLATE_EVENTS_PAGE_COUNT = 5;
